import * as e from "react";
import { useState as $, useEffect as Z, useRef as Y, useCallback as _e, Fragment as at } from "react";
import { m as nt, e as ot, c as st } from "./format-DVsMuX33.js";
import { a as Nl, b as $l, f as wl, d as Al, g as xl, h as Xl, i as Cl, j as Sl, k as Fl, t as Bl } from "./format-DVsMuX33.js";
import { c1 as Ke } from "./OBTResizeContainer-BnqEXBJe.js";
import { A as Ll, a as Il, b as Dl, c as Ml, d as Tl, e as Rl, C as Pl, f as Ol, g as ql, h as Gl, i as zl, j as Wl, k as Kl, l as Hl, m as Ul, n as Vl, o as Ql, p as Jl, q as Yl, r as Zl, s as ei, t as ti, u as ai, v as ni, w as oi, x as si, y as ri, z as ci, B as li, D as ii, E as di, F as _i, G as mi, H as ui, I as pi, J as Ei, K as bi, L as fi, M as yi, N as gi, O as hi, P as vi, Q as ki, R as Ni, S as $i, T as wi, U as Ai, V as xi, W as Xi, X as Ci, Y as Si, Z as Fi, _ as Bi, $ as ji, a0 as Li, a1 as Ii, a2 as Di, a3 as Mi, a4 as Ti, a5 as Ri, a6 as Pi, a7 as Oi, a8 as qi, a9 as Gi, aa as zi, ab as Wi, ac as Ki, ad as Hi, ae as Ui, af as Vi, ag as Qi, ah as Ji, ai as Yi, aj as Zi, ak as ed, al as td, am as ad, an as nd, ao as od, ap as sd, aq as rd, ar as cd, as as ld, at as id, au as dd, av as _d, aw as md, ax as ud, ay as pd, az as Ed, aA as bd, aB as fd, aC as yd, aD as gd, aE as hd, aF as vd, aG as kd, aH as Nd, aI as $d, aJ as wd, aK as Ad, aL as xd, aM as Xd, aN as Cd, aO as Sd, c2 as Fd, aP as Bd, aQ as jd, aR as Ld, aS as Id, aT as Dd, aU as Md, aV as Td, aW as Rd, aX as Pd, aY as Od, aZ as qd, a_ as Gd, a$ as zd, b0 as Wd, b1 as Kd, b2 as Hd, b3 as Ud, b4 as Vd, b5 as Qd, b6 as Jd, b7 as Yd, b8 as Zd, b9 as e_, ba as t_, bb as a_, bc as n_, bd as o_, be as s_, bf as r_, bg as c_, bh as l_, bi as i_, bj as d_, bk as __, bl as m_, bm as u_, bn as p_, bo as E_, bp as b_, bq as f_, br as y_, bs as g_, bt as h_, bu as v_, bv as k_, bw as N_, bx as $_, by as w_, bz as A_, bA as x_, bB as X_, bC as C_, bD as S_, bE as F_, bF as B_, bG as j_, bH as L_, bI as I_, bJ as D_, bK as M_, bL as T_, bM as R_, bN as P_, bO as O_, bP as q_, bQ as G_, bR as z_, bS as W_, bT as K_, bU as H_, bV as U_, bW as V_, bX as Q_, bY as J_, bZ as Y_, b_ as Z_, b$ as em, c0 as tm } from "./OBTResizeContainer-BnqEXBJe.js";
const Ic = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Be = "poc_portal_token", ge = "poc_portal_refresh", Xe = "auth:session-expired", je = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let He = je + "/chat-api/api/auth";
function Dc(t) {
  t.authBase && (He = t.authBase);
}
function we(t) {
  try {
    const a = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(a))));
  } catch {
    return {};
  }
}
function rt(t, a = 30) {
  const n = we(t).exp;
  return !n || n * 1e3 < Date.now() + a * 1e3;
}
function Ue(t = 30) {
  const a = localStorage.getItem(ge);
  if (!a) return !0;
  const n = we(a).exp;
  return !!n && n * 1e3 < Date.now() + t * 1e3;
}
function Ve() {
  return localStorage.getItem(Be);
}
function ct(t, a) {
  localStorage.setItem(Be, t), a && localStorage.setItem(ge, a);
}
function lt() {
  localStorage.removeItem(Be), localStorage.removeItem(ge), Qe();
}
function fe() {
  lt(), window.dispatchEvent(new Event(Xe));
}
function Mc(t) {
  return window.addEventListener(Xe, t), () => window.removeEventListener(Xe, t);
}
let ye = null;
const it = 2147483647;
function dt() {
  if (Qe(), Ue()) {
    fe();
    return;
  }
  const t = localStorage.getItem(ge), a = t ? we(t).exp : void 0;
  if (!a) return;
  const n = Math.min(Math.max(a * 1e3 - Date.now() - 30 * 1e3, 0), it);
  ye = setTimeout(() => {
    ye = null, dt();
  }, n);
}
function Qe() {
  ye !== null && (clearTimeout(ye), ye = null);
}
let $e = null;
function Je() {
  return $e || ($e = _t()), $e;
}
async function _t() {
  try {
    return await mt();
  } finally {
    $e = null;
  }
}
async function mt() {
  const t = localStorage.getItem(ge);
  if (!t)
    return fe(), null;
  let a;
  try {
    a = await fetch(He + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!a.ok)
    return a.status < 500 && fe(), null;
  const n = await a.json().catch(() => ({}));
  return n.access_token ? (ct(n.access_token, n.refresh_token), n.access_token) : (fe(), null);
}
async function ut() {
  if (Ue())
    return fe(), null;
  const t = Ve();
  return t && !rt(t) ? t : Je();
}
const Ce = "poc_portal_active_aff:", pt = "X-Active-Com", Et = "X-Active-Dept";
function Ye(t = Ve()) {
  return t && we(t).preferred_username || null;
}
function Ze(t = Ye()) {
  if (!t) return null;
  try {
    const a = localStorage.getItem(Ce + t);
    if (!a) return null;
    const n = JSON.parse(a);
    if (Number.isInteger(n == null ? void 0 : n.comSq) && typeof (n == null ? void 0 : n.deptCd) == "string" && n.deptCd)
      return { comSq: n.comSq, deptCd: n.deptCd };
  } catch {
  }
  return null;
}
function Tc(t, a) {
  if (t)
    try {
      a ? localStorage.setItem(Ce + t, JSON.stringify(a)) : localStorage.removeItem(Ce + t);
    } catch {
    }
}
function bt(t) {
  const a = Ze(Ye(t));
  return a ? { [pt]: String(a.comSq), [Et]: a.deptCd } : {};
}
async function le(t, a = {}) {
  const n = (s) => {
    var m;
    const l = (m = a.headers) != null ? m : {}, d = Object.keys(l).map((_) => _.toLowerCase()), c = bt(s), i = {};
    return Object.keys(c).forEach((_) => {
      d.indexOf(_.toLowerCase()) < 0 && (i[_] = c[_]);
    }), {
      ...a,
      headers: { ...l, ...s ? { Authorization: "Bearer " + s } : {}, ...i }
    };
  }, o = await ut();
  let r = await fetch(t, n(o));
  if (r.status === 401 && o) {
    const s = await Je();
    s && (r = await fetch(t, n(s)));
  }
  return r;
}
const ft = "JPY";
let ve = null;
function yt() {
  return ve || (ve = le(`${je}/chat-api/api/basicinfo/companies`).then((t) => t.ok ? t.json() : []).catch(() => []).then((t) => (t.length || (ve = null), t))), ve;
}
function gt(t, a) {
  var o, r, s;
  const n = (o = t.find((l) => l.comSq === a)) != null ? o : t[0];
  return n && (s = (r = n.dispCurCd) != null ? r : n.baseCurCd) != null ? s : null;
}
function ht(t) {
  return { code: t, digits: st(t), fmt: (a) => ot(a, t), unit: nt(t) };
}
function vt() {
  const [t, a] = $(ft);
  return Z(() => {
    let n = !0;
    return yt().then((o) => {
      var s;
      const r = gt(o, (s = Ze()) == null ? void 0 : s.comSq);
      n && r && a(r);
    }), () => {
      n = !1;
    };
  }, []), ht(t);
}
function Rc({ className: t }) {
  const { unit: a } = vt();
  return /* @__PURE__ */ e.createElement("span", { className: t, "data-currency-unit": !0 }, a);
}
let ie = je + "/chat-api/api/comments";
function Pc(t) {
  t.base && (ie = t.base);
}
function kt(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function he(t) {
  const a = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error("요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.");
  return a;
}
async function Le(t, a, n, o, r) {
  const s = new URLSearchParams({ targetType: t, targetId: a, page: String(n), size: String(o) }), l = await le(`${ie}?${s}`, { cache: "no-store", signal: r });
  return he(l);
}
async function Nt(t, a, n, o) {
  const r = await le(ie, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: a, content: n, parentId: o })
  });
  return he(r);
}
async function $t(t, a) {
  const n = await le(`${ie}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: a })
  });
  return he(n);
}
async function wt(t) {
  const a = await le(`${ie}/${t}`, { method: "DELETE" });
  return (await he(a)).status;
}
async function At(t, a, n) {
  if (a.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: a.join(",") }), r = await le(`${ie}/counts?${o}`, { cache: "no-store", signal: n });
  return (await he(r)).counts;
}
const Ie = 50;
function Se(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function xt(t, a) {
  if (Se(a)) return [...t, a];
  const n = a.parentId;
  let o = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === n || t[r].parentId === n) && (o = r);
  return o < 0 ? [...t, a] : [...t.slice(0, o + 1), a, ...t.slice(o + 1)];
}
function me(t, a) {
  return a;
}
function Xt(t, a) {
  const [n, o] = $([]), [r, s] = $(!0), [l, d] = $(!0), [c, i] = $(null), [m, _] = $(0), [u, b] = $(0), y = t + " " + a, E = Y(y);
  E.current = y;
  const [h, w] = $(0), X = _e(() => w((f) => f + 1), []);
  Z(() => {
    const f = new AbortController(), v = y;
    return o([]), b(0), _(0), i(null), s(!0), d(!0), Le(t, a, 0, Ie, f.signal).then((g) => {
      E.current === v && (o(g.items), _(g.total));
    }).catch((g) => {
      f.signal.aborted || E.current !== v || i(me(g, "댓글을 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && (s(!1), d(!1));
    }), () => f.abort();
  }, [t, a, y, h]);
  const O = n.filter(Se).length < m, q = _e(() => {
    if (r || !O) return;
    const f = u + 1, v = E.current;
    s(!0), Le(t, a, f, Ie).then((g) => {
      E.current === v && (o((S) => [...S, ...g.items]), _(g.total), b(f));
    }).catch((g) => {
      E.current === v && i(me(g, "댓글을 더 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && s(!1);
    });
  }, [r, O, u, t, a]), U = _e(async (f, v) => {
    const g = f.trim();
    if (!g) return !1;
    const S = -Date.now(), F = {
      id: S,
      targetType: t,
      targetId: a,
      parentId: v != null ? v : null,
      authorName: "나",
      content: g,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, D = E.current;
    o((L) => xt(L, F)), i(null);
    try {
      const L = await Nt(t, a, g, v);
      return E.current !== D || (o((V) => V.map((k) => k.id === S ? L : k)), v === void 0 && _((V) => V + 1)), !0;
    } catch (L) {
      return E.current !== D || (o((V) => V.filter((k) => k.id !== S)), i(me(L, "댓글을 등록하지 못했습니다."))), !1;
    }
  }, [t, a]), C = _e(async (f, v) => {
    const g = v.trim();
    if (!g) return !1;
    const S = E.current;
    try {
      const F = await $t(f, g);
      return E.current !== S || o((D) => D.map((L) => L.id === f ? F : L)), !0;
    } catch (F) {
      return E.current === S && i(me(F, "댓글을 수정하지 못했습니다.")), !1;
    }
  }, []), de = _e(async (f) => {
    const v = E.current;
    try {
      const g = await wt(f);
      return E.current !== v ? !0 : g === "soft-deleted" ? (o((S) => S.map((F) => F.id === f ? { ...F, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : F)), !0) : (o((S) => {
        const F = S.find((k) => k.id === f), D = S.filter((k) => k.id !== f);
        if (!F) return D;
        if (Se(F))
          return _((k) => Math.max(0, k - 1)), D;
        const L = F.parentId, V = D.find((k) => k.id === L);
        return V && V.deleted && !D.some((k) => k.parentId === L) ? (_((k) => Math.max(0, k - 1)), D.filter((k) => k.id !== L)) : D;
      }), !0);
    } catch (g) {
      return E.current === v && i(me(g, "댓글을 삭제하지 못했습니다.")), !1;
    }
  }, []);
  return {
    items: n,
    loading: r,
    initialLoading: l,
    error: c,
    count: n.filter((f) => !f.deleted).length,
    hasMore: O,
    loadMore: q,
    reload: X,
    add: U,
    edit: C,
    remove: de
  };
}
const Ct = "_thread_1layy_9", St = "_head_1layy_28", Ft = "_headTitle_1layy_37", Bt = "_headCount_1layy_43", jt = "_list_1layy_54", Lt = "_row_1layy_61", It = "_isReply_1layy_73", Dt = "_pending_1layy_80", Mt = "_avatar_1layy_84", Tt = "_avatarGhost_1layy_98", Rt = "_body_1layy_103", Pt = "_meta_1layy_108", Ot = "_author_1layy_116", qt = "_dept_1layy_122", Gt = "_time_1layy_130", zt = "_text_1layy_135", Wt = "_textDeleted_1layy_143", Kt = "_acts_1layy_148", Ht = "_act_1layy_148", Ut = "_actDanger_1layy_169", Vt = "_empty_1layy_175", Qt = "_error_1layy_182", Jt = "_skeleton_1layy_196", Yt = "_more_1layy_219", Zt = "_foot_1layy_245", ea = "_composer_1layy_252", ta = "_composerInput_1layy_261", aa = "_composerActions_1layy_284", na = "_btn_1layy_291", oa = "_btnPrimary_1layy_301", sa = "_btnGhost_1layy_310", p = {
  thread: Ct,
  head: St,
  headTitle: Ft,
  headCount: Bt,
  list: jt,
  row: Lt,
  isReply: It,
  pending: Dt,
  avatar: Mt,
  avatarGhost: Tt,
  body: Rt,
  meta: Pt,
  author: Ot,
  dept: qt,
  time: Gt,
  text: zt,
  textDeleted: Wt,
  acts: Kt,
  act: Ht,
  actDanger: Ut,
  empty: Vt,
  error: Qt,
  skeleton: Jt,
  more: Yt,
  foot: Zt,
  composer: ea,
  composerInput: ta,
  composerActions: aa,
  btn: na,
  btnPrimary: oa,
  btnGhost: sa
}, De = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function ra(t) {
  let a = 0;
  for (let n = 0; n < t.length; n += 1) a = (a * 31 + t.charCodeAt(n)) % 997;
  return De[a % De.length];
}
function ca(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "?";
}
const Me = 6e4, Te = 36e5, Re = 864e5, la = 6048e5;
function ia(t) {
  const a = new Date(t).getTime();
  if (Number.isNaN(a)) return "";
  const n = Date.now() - a;
  if (n < Me) return "방금";
  if (n < Te) return `${Math.floor(n / Me)}분 전`;
  if (n < Re) return `${Math.floor(n / Te)}시간 전`;
  if (n < la) return `${Math.floor(n / Re)}일 전`;
  const o = new Date(a), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function Fe({
  placeholder: t,
  submitLabel: a,
  autoFocus: n,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, d] = $(o != null ? o : ""), [c, i] = $(!1), m = Y(null);
  Z(() => {
    n && m.current && m.current.focus();
  }, [n]);
  const _ = async () => {
    const u = l.trim();
    if (!u || c) return;
    i(!0);
    const b = await r(u);
    i(!1), b && d("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: p.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: p.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: c,
      onChange: (u) => d(u.target.value),
      onKeyDown: (u) => {
        const b = u.nativeEvent.isComposing;
        u.key === "Enter" && !u.shiftKey && !b && (u.preventDefault(), _()), u.key === "Escape" && s && (u.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: p.composerActions }, s && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnPrimary}`,
      onClick: () => void _(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : a
  )));
}
function da({
  item: t,
  replying: a,
  editing: n,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: d,
  onCancel: c
}) {
  var u, b;
  const i = kt(t), m = i ? ` ${p.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${p.avatar} ${p.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: `${p.text} ${p.textDeleted}` }, "삭제된 댓글입니다")));
  const _ = (u = t.authorName) != null ? u : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}${t.pending ? ` ${p.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: p.avatar, style: { background: ra(_) } }, ca(_)), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: p.meta }, /* @__PURE__ */ e.createElement("span", { className: p.author }, _), t.dept && /* @__PURE__ */ e.createElement("span", { className: p.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: p.time }, ia(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: p.time }, "(수정됨)")), n ? /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: p.text }, t.content), !n && !t.pending && /* @__PURE__ */ e.createElement("div", { className: p.acts }, !i && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.act} ${p.actDanger}`,
      onClick: d
    },
    "삭제"
  )), a && /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: `${_} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function Oc({
  targetType: t,
  targetId: a,
  onCountChange: n,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: d, initialLoading: c, loading: i, error: m, count: _, hasMore: u, loadMore: b, reload: y, add: E, edit: h, remove: w } = Xt(t, a), [X, T] = $(null), [O, q] = $(null);
  Z(() => {
    T(null), q(null);
  }, [t, a]);
  const U = Y(n);
  return U.current = n, Z(() => {
    !c && U.current && U.current(_);
  }, [_, c]), /* @__PURE__ */ e.createElement("div", { className: s ? `${p.thread} ${s}` : p.thread, style: l }, r && /* @__PURE__ */ e.createElement("div", { className: p.head }, /* @__PURE__ */ e.createElement("span", { className: p.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: p.headCount }, _)), /* @__PURE__ */ e.createElement("div", { className: p.list }, c && /* @__PURE__ */ e.createElement("div", { className: p.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: p.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !m && d.length === 0 && /* @__PURE__ */ e.createElement("div", { className: p.empty }, "첫 댓글을 남겨 보세요."), d.map((C) => /* @__PURE__ */ e.createElement(
    da,
    {
      key: C.id,
      item: C,
      replying: X === C.id,
      editing: O === C.id,
      onReply: () => {
        q(null), T(C.id);
      },
      onEdit: () => {
        T(null), q(C.id);
      },
      onCancel: () => {
        T(null), q(null);
      },
      onSubmitReply: async (de) => {
        const f = await E(de, C.id);
        return f && T(null), f;
      },
      onSubmitEdit: async (de) => {
        const f = await h(C.id, de);
        return f && q(null), f;
      },
      onDelete: () => {
        w(C.id);
      }
    }
  )), u && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.more, onClick: b, disabled: i }, i ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: p.foot }, /* @__PURE__ */ e.createElement(
    Fe,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (C) => E(C)
    }
  )));
}
function qc(t, a) {
  const [n, o] = $({}), [r, s] = $(!1), [l, d] = $(0), c = a.join(",");
  return Z(() => {
    const i = c ? c.split(",") : [];
    if (i.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), At(t, i, m.signal).then((_) => {
      m.signal.aborted || o(_);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [t, c, l]), {
    counts: n,
    loading: r,
    reload: () => d((i) => i + 1)
  };
}
const _a = "_card_epi3f_1", ma = "_header_epi3f_8", ua = "_headerNoDivider_epi3f_13", pa = "_body_epi3f_17", Ea = "_paddingSm_epi3f_22", ba = "_paddingMd_epi3f_26", fa = "_paddingLg_epi3f_30", G = {
  card: _a,
  header: ma,
  headerNoDivider: ua,
  body: pa,
  paddingSm: Ea,
  paddingMd: ba,
  paddingLg: fa
};
function Gc({
  children: t,
  header: a,
  padding: n = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: d,
  className: c
}) {
  const i = typeof n == "number" ? "" : n === "sm" ? G.paddingSm : n === "lg" ? G.paddingLg : G.paddingMd, m = typeof n == "number" ? { padding: n } : void 0, _ = c ? `${G.card} ${c}` : G.card, u = r ? G.header : `${G.header} ${G.headerNoDivider}`, b = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...d !== void 0 ? { borderBottomColor: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: _, style: o !== void 0 ? { borderRadius: o } : void 0 }, a && /* @__PURE__ */ e.createElement("div", { className: u, style: b }, a), /* @__PURE__ */ e.createElement("div", { className: `${G.body} ${i}`, style: m }, t));
}
const ya = "_horizontal_mkht7_1", ga = "_vertical_mkht7_8", Pe = {
  horizontal: ya,
  vertical: ga
};
function zc({ orientation: t = "horizontal", spacing: a = 0, color: n }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? Pe.vertical : Pe.horizontal,
      style: {
        ...o ? { marginLeft: a, marginRight: a } : { marginTop: a, marginBottom: a },
        ...n !== void 0 ? { backgroundColor: n } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const ha = "_root_nvy8t_1", va = "_icon_nvy8t_7", ka = "_iconBadge_nvy8t_15", Na = "_titleGroup_nvy8t_25", $a = "_title_nvy8t_25", wa = "_subtitle_nvy8t_41", Aa = "_trailing_nvy8t_49", xa = "_closeButton_nvy8t_58", Q = {
  root: ha,
  icon: va,
  iconBadge: ka,
  titleGroup: Na,
  title: $a,
  subtitle: wa,
  trailing: Aa,
  closeButton: xa
};
function Wc({
  icon: t,
  iconColor: a,
  iconBadge: n = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: d,
  titleSize: c,
  subtitle: i,
  subtitleColor: m,
  subtitleSize: _,
  trailing: u,
  onClose: b
}) {
  const y = {
    ...d !== void 0 ? { fontWeight: d } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, E = {
    ...m !== void 0 ? { color: m } : {},
    ..._ !== void 0 ? { fontSize: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: Q.root }, t && n && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Q.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    t
  ), t && !n && /* @__PURE__ */ e.createElement("span", { className: Q.icon, style: a !== void 0 ? { color: a } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: Q.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: Q.title, style: y }, l), i && /* @__PURE__ */ e.createElement("span", { className: Q.subtitle, style: E }, i)), u && /* @__PURE__ */ e.createElement("div", { className: Q.trailing }, u), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Q.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const Xa = "_badge_19977_1", Ca = {
  badge: Xa
};
function Kc({
  size: t = 32,
  gradient: a = ["#7C3AED", "#3B82F6"],
  icon: n
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ca.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${a[0]}, ${a[1]})`
      }
    },
    n != null ? n : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const Sa = "_wrapper_ccmq2_1", Fa = "_image_ccmq2_8", Ba = "_fallback_ccmq2_16", ja = "_statusDot_ccmq2_29", ke = {
  wrapper: Sa,
  image: Fa,
  fallback: Ba,
  statusDot: ja
}, La = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function Ia(t) {
  const a = t == null ? void 0 : t.trim();
  return a ? Array.from(a)[0].toUpperCase() : "";
}
const Ae = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function Da(t) {
  const a = t == null ? void 0 : t.trim();
  if (!a) return Ae[5];
  let n = 0;
  for (let o = 0; o < a.length; o += 1)
    n = n * 31 + a.charCodeAt(o) | 0;
  return Ae[Math.abs(n) % Ae.length];
}
function et({
  src: t,
  fallbackText: a,
  alt: n,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: d = "#fff"
}) {
  var _;
  const [c, i] = $(), m = !!t && c !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ke.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${d}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: ke.image,
        src: t,
        alt: (_ = n != null ? n : a) != null ? _ : "",
        onError: () => i(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ke.fallback,
        style: {
          backgroundColor: s != null ? s : Da(a),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      Ia(a)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ke.statusDot,
        style: {
          backgroundColor: La[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const Ma = "_stack_y8phg_1", Ta = "_item_y8phg_6", Ra = "_overflow_y8phg_18", Ne = {
  stack: Ma,
  item: Ta,
  overflow: Ra
};
function Hc({
  avatars: t,
  max: a = 4,
  size: n = 32
}) {
  const o = t.slice(0, a), r = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: Ne.stack }, o.map((s, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: Ne.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ e.createElement(et, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: n }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: Ne.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ne.overflow,
      style: { width: n, height: n, fontSize: Math.max(10, n * 0.36) }
    },
    "+",
    r
  )));
}
const Pa = "_badge_1mjda_1", Oa = "_pill_1mjda_15", qa = "_dot_1mjda_19", Ga = "_dotPulse_1mjda_26", za = "_outline_1mjda_40", Wa = "_soft_1mjda_46", ue = {
  badge: Pa,
  pill: Oa,
  dot: qa,
  dotPulse: Ga,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: za,
  soft: Wa
};
function Uc({
  label: t,
  variant: a = "default",
  color: n,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: d,
  dotPulse: c = !1,
  border: i = !1,
  borderColor: m = "currentColor"
}) {
  var y;
  const _ = {};
  n && (a === "default" ? (_.backgroundColor = n, _.color = "#fff") : a === "outline" ? (_.borderColor = n, _.color = n) : (_.backgroundColor = `${n}1A`, _.color = n)), o !== void 0 && (_.backgroundColor = o), r !== void 0 && (_.color = r), i && (_.borderColor = m);
  const u = [
    ue.badge,
    ue[a],
    s === "pill" ? ue.pill : ""
  ].filter(Boolean).join(" "), b = [ue.dot, c ? ue.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: u, style: _ }, l && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: d != null ? d : (y = r != null ? r : n) != null ? y : "currentColor" } }), t);
}
const Ka = "_row_1k2ap_1", Ha = "_reply_1k2ap_7", Ua = "_avatar_1k2ap_12", Va = "_avatarImage_1k2ap_25", Qa = "_avatarFallback_1k2ap_32", Ja = "_body_1k2ap_44", Ya = "_headerLine_1k2ap_49", Za = "_author_1k2ap_56", en = "_meta_1k2ap_62", tn = "_text_1k2ap_67", an = "_actionsRow_1k2ap_74", nn = "_actionBtn_1k2ap_81", B = {
  row: Ka,
  reply: Ha,
  avatar: Ua,
  avatarImage: Va,
  avatarFallback: Qa,
  body: Ja,
  headerLine: Ya,
  author: Za,
  meta: en,
  text: tn,
  actionsRow: an,
  actionBtn: nn
};
function on(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "";
}
function Vc({
  avatarSrc: t,
  author: a,
  meta: n,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: d,
  onReplyClick: c
}) {
  const [i, m] = $(!1), _ = !!t && !i;
  return /* @__PURE__ */ e.createElement("div", { className: `${B.row} ${l ? B.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: B.avatar }, _ ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: B.avatarImage,
      src: t,
      alt: a,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: B.avatarFallback }, on(a))), /* @__PURE__ */ e.createElement("div", { className: B.body }, /* @__PURE__ */ e.createElement("div", { className: B.headerLine }, /* @__PURE__ */ e.createElement("span", { className: B.author }, a), n && /* @__PURE__ */ e.createElement("span", { className: B.meta }, n)), /* @__PURE__ */ e.createElement("div", { className: B.text }, o), /* @__PURE__ */ e.createElement("div", { className: B.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: d }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)))));
}
const sn = "_wrapper_79n51_1", rn = {
  wrapper: sn
}, cn = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, ln = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function dn({ ext: t, size: a = 32 }) {
  var l;
  const n = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = cn[n]) != null ? l : ln;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: rn.wrapper,
      style: {
        width: a,
        height: a,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, a * 0.26)
      }
    },
    o
  );
}
const _n = "_chip_1jhj8_1", mn = "_clickable_1jhj8_12", un = "_icon_1jhj8_21", pn = "_info_1jhj8_26", En = "_name_1jhj8_33", bn = "_size_1jhj8_42", fn = "_chipError_1jhj8_48", yn = "_chipDone_1jhj8_53", gn = "_status_1jhj8_57", hn = "_statusError_1jhj8_66", vn = "_statusDone_1jhj8_67", kn = "_statusIcon_1jhj8_69", Nn = "_statusLabel_1jhj8_71", $n = "_progressTrack_1jhj8_78", wn = "_progressFill_1jhj8_88", An = "_actionBtn_1jhj8_96", N = {
  chip: _n,
  clickable: mn,
  icon: un,
  info: pn,
  name: En,
  size: bn,
  chipError: fn,
  chipDone: yn,
  status: gn,
  statusError: hn,
  statusDone: vn,
  statusIcon: kn,
  statusLabel: Nn,
  progressTrack: $n,
  progressFill: wn,
  actionBtn: An
};
function Qc({
  name: t,
  ext: a,
  size: n,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: d,
  percent: c
}) {
  const i = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${s ? N.clickable : ""} ${i}`,
      onClick: s,
      title: l === "error" ? d : void 0
    },
    a && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(dn, { ext: a, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), d ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, d)) : n ? /* @__PURE__ */ e.createElement("span", { className: N.size }, n) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "내려받기",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "삭제",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const xn = "_list_1yxwc_1", Xn = "_row_1yxwc_6", Cn = "_inline_1yxwc_15", Sn = "_label_1yxwc_22", Fn = "_value_1yxwc_29", Bn = "_stacked_1yxwc_35", jn = "_bold_1yxwc_51", ne = {
  list: xn,
  row: Xn,
  inline: Cn,
  label: Sn,
  value: Fn,
  stacked: Bn,
  bold: jn
};
function Jc({
  rows: t,
  direction: a = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${ne.list} ${ne[a]}` }, t.map((n, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: ne.row }, /* @__PURE__ */ e.createElement("span", { className: ne.label }, n.label), /* @__PURE__ */ e.createElement("span", { className: `${ne.value} ${n.bold ? ne.bold : ""}` }, n.value))));
}
const Ln = "_container_2r163_1", In = "_row_2r163_5", Dn = "_clickable_2r163_12", Mn = "_leading_2r163_20", Tn = "_main_2r163_26", Rn = "_titleLine_2r163_34", Pn = "_title_2r163_34", On = "_tags_2r163_50", qn = "_meta_2r163_57", Gn = "_actions_2r163_62", zn = "_expandable_2r163_69", M = {
  container: Ln,
  row: In,
  clickable: Dn,
  leading: Mn,
  main: Tn,
  titleLine: Rn,
  title: Pn,
  tags: On,
  meta: qn,
  actions: Gn,
  expandable: zn
};
function Yc({
  leading: t,
  title: a,
  meta: n,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: d
}) {
  return /* @__PURE__ */ e.createElement("div", { className: M.container }, /* @__PURE__ */ e.createElement("div", { className: `${M.row} ${d ? M.clickable : ""}`, onClick: d }, t && /* @__PURE__ */ e.createElement("div", { className: M.leading }, t), /* @__PURE__ */ e.createElement("div", { className: M.main }, /* @__PURE__ */ e.createElement("div", { className: M.titleLine }, /* @__PURE__ */ e.createElement("span", { className: M.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: M.tags }, o)), n && /* @__PURE__ */ e.createElement("div", { className: M.meta }, n)), r && /* @__PURE__ */ e.createElement("div", { className: M.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ e.createElement("div", { className: M.expandable }, s));
}
const Wn = "_row_xzgny_1", Kn = "_info_xzgny_8", Hn = "_name_xzgny_16", Un = "_subtitle_xzgny_25", Vn = "_status_xzgny_33", pe = {
  row: Wn,
  info: Kn,
  name: Hn,
  subtitle: Un,
  status: Vn
};
function Zc({
  avatarSrc: t,
  name: a,
  subtitle: n,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: pe.row }, /* @__PURE__ */ e.createElement(et, { src: t, fallbackText: a, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: pe.info }, /* @__PURE__ */ e.createElement("span", { className: pe.name }, a), n && /* @__PURE__ */ e.createElement("span", { className: pe.subtitle }, n)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: pe.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const Qn = "_row_qoxwr_1", Jn = "_clickable_qoxwr_9", Yn = "_rank_qoxwr_17", Zn = "_title_qoxwr_25", eo = "_trailing_qoxwr_36", Ee = {
  row: Qn,
  clickable: Jn,
  rank: Yn,
  title: Zn,
  trailing: eo
}, to = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function el({
  rank: t,
  rankColor: a,
  title: n,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = a != null ? a : to[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${Ee.row} ${r ? Ee.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: Ee.rank, style: { color: s } }, t), /* @__PURE__ */ e.createElement("span", { className: Ee.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: Ee.trailing }, o));
}
const ao = "_badge_1qibj_1", no = "_sm_1qibj_11", oo = "_md_1qibj_16", so = "_overdue_1qibj_21", ro = "_warning_1qibj_26", co = "_progress_1qibj_31", lo = "_success_1qibj_36", io = "_info_1qibj_41", _o = "_neutral_1qibj_46", xe = {
  badge: ao,
  sm: no,
  md: oo,
  overdue: so,
  warning: ro,
  progress: co,
  success: lo,
  info: io,
  neutral: _o
};
function tl({
  label: t,
  tone: a = "neutral",
  size: n = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ e.createElement("span", { className: `${xe.badge} ${xe[a]} ${xe[n]}`, style: s }, t);
}
const mo = "_wrapper_14p14_1", uo = "_avatar_14p14_11", po = "_body_14p14_21", Eo = "_message_14p14_26", bo = "_dots_14p14_32", fo = "_dot_14p14_32", yo = "_action_14p14_70", go = "_actionIcon_14p14_89", ho = "_gradientWrapper_14p14_95", vo = "_bareIcon_14p14_100", ko = "_ctaButton_14p14_109", A = {
  wrapper: mo,
  avatar: uo,
  body: po,
  message: Eo,
  dots: bo,
  dot: fo,
  action: yo,
  actionIcon: go,
  gradientWrapper: ho,
  bareIcon: vo,
  ctaButton: ko
};
function Oe() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function qe() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function al({
  message: t,
  accentColor: a = "#7C3AED",
  buttonLabel: n,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: d = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [A.wrapper, c ? A.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${a}33`, background: `linear-gradient(135deg, ${d[0]}, ${d[1]})` } : { borderColor: `${a}33` }
    },
    c ? /* @__PURE__ */ e.createElement("span", { className: A.bareIcon, style: { color: a } }, /* @__PURE__ */ e.createElement(Oe, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: A.avatar,
        style: { backgroundColor: `${a}1A`, color: a }
      },
      /* @__PURE__ */ e.createElement(Oe, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: A.body }, s === "loading" ? /* @__PURE__ */ e.createElement("span", { className: A.dots }, /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: A.dot, style: { backgroundColor: a } })) : /* @__PURE__ */ e.createElement("span", { className: A.message, style: c ? { color: a } : void 0 }, t)),
    n && r && (c ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: A.ctaButton,
        style: { backgroundColor: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: A.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(qe, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: A.action,
        style: { color: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: A.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(qe, null) : o)
    ))
  );
}
const No = "_wrapper_68zkp_1", $o = "_bordered_68zkp_13", wo = "_compact_68zkp_17", Ao = "_icon_68zkp_23", xo = "_title_68zkp_31", Xo = "_description_68zkp_38", Co = "_action_68zkp_46", ee = {
  wrapper: No,
  bordered: $o,
  compact: wo,
  icon: Ao,
  title: xo,
  description: Xo,
  action: Co
};
function So() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function nl({
  icon: t,
  hideIcon: a = !1,
  title: n,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: d,
  onAction: c,
  bordered: i = !0,
  compact: m = !1
}) {
  const _ = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ee.wrapper, i && !m ? ee.bordered : "", m ? ee.compact : ""].join(" ")
    },
    !a && /* @__PURE__ */ e.createElement("div", { className: ee.icon }, t != null ? t : /* @__PURE__ */ e.createElement(So, null)),
    /* @__PURE__ */ e.createElement("p", { className: ee.title, style: _ }, n),
    l && /* @__PURE__ */ e.createElement("p", { className: ee.description }, l),
    d && c && /* @__PURE__ */ e.createElement("button", { type: "button", className: ee.action, onClick: c }, d)
  );
}
const Fo = "_wrapper_oide4_1", Bo = "_toggle_oide4_7", jo = "_toggleOpen_oide4_29", Lo = "_panel_oide4_34", Io = "_text_oide4_41", be = {
  wrapper: Fo,
  toggle: Bo,
  toggleOpen: jo,
  panel: Lo,
  text: Io
};
function ol({
  label: t,
  summaryText: a,
  open: n,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: be.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [be.toggle, n ? be.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": n
    },
    t
  ), n && /* @__PURE__ */ e.createElement("div", { className: be.panel }, /* @__PURE__ */ e.createElement("p", { className: be.text }, a)));
}
const Do = "_wrapper_96dw1_1", Mo = "_labelRow_96dw1_8", To = "_label_96dw1_8", Ro = "_value_96dw1_21", Po = "_track_96dw1_27", Oo = "_xs_96dw1_35", qo = "_sm_96dw1_39", Go = "_md_96dw1_43", zo = "_square_96dw1_47", Wo = "_fill_96dw1_51", z = {
  wrapper: Do,
  labelRow: Mo,
  label: To,
  value: Ro,
  track: Po,
  xs: Oo,
  sm: qo,
  md: Go,
  square: zo,
  fill: Wo
};
function sl({
  value: t,
  max: a = 100,
  label: n,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: d,
  trackColor: c
}) {
  const i = a > 0 ? a : 100, m = Math.min(100, Math.max(0, t / i * 100)), _ = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: o }, u = {
    ...d !== void 0 ? { height: d } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: z.wrapper }, n && /* @__PURE__ */ e.createElement("div", { className: z.labelRow }, /* @__PURE__ */ e.createElement("span", { className: z.label }, n), /* @__PURE__ */ e.createElement("span", { className: z.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [z.track, z[s], l ? "" : z.square].join(" "), style: u }, /* @__PURE__ */ e.createElement("div", { className: [z.fill, l ? "" : z.square].join(" "), style: _ })));
}
const Ko = "_list_aixh6_1", Ho = "_vertical_aixh6_8", Uo = "_horizontal_aixh6_13", Vo = "_item_aixh6_18", Qo = "_iconWrap_aixh6_41", Jo = "_iconSvg_aixh6_51", Yo = "_spin_aixh6_56", Zo = "_label_aixh6_70", es = "_item_active_aixh6_82", ts = "_item_done_aixh6_87", as = "_connector_aixh6_91", ns = "_cardList_aixh6_114", os = "_cardItem_aixh6_122", ss = "_card_pending_aixh6_133", rs = "_card_active_aixh6_142", cs = "_card_done_aixh6_152", x = {
  list: Ko,
  vertical: Ho,
  horizontal: Uo,
  item: Vo,
  iconWrap: Qo,
  iconSvg: Jo,
  spin: Yo,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: Zo,
  item_active: es,
  item_done: ts,
  connector: as,
  cardList: ns,
  cardItem: os,
  card_pending: ss,
  card_active: rs,
  card_done: cs
};
function ls({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [x.iconSvg, x.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function rl({
  steps: t,
  orientation: a = "vertical",
  variant: n = "timeline"
}) {
  const o = n === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [x.list, x[a], o ? x.cardList : ""].join(" ") }, t.map((r, s) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        x.item,
        o ? x.cardItem : "",
        x[`item_${r.status}`],
        o ? x[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: x.iconWrap }, /* @__PURE__ */ e.createElement(ls, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: x.label }, r.label),
    !o && s < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: x.connector })
  )));
}
const is = "_wrapper_1ohmw_1", ds = "_icon_1ohmw_7", _s = "_dots_1ohmw_14", ms = "_dot_1ohmw_14", us = "_sm_1ohmw_27", ps = "_md_1ohmw_32", te = {
  wrapper: is,
  icon: ds,
  dots: _s,
  dot: ms,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: us,
  md: ps
};
function cl({ withIcon: t, size: a = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: te.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: te.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [te.dots, te[a]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot })));
}
const Es = "_container_85404_1", bs = "_table_85404_9", fs = "_row_85404_31", ys = "_striped_85404_35", gs = "_clickable_85404_43", hs = "_alignLeft_85404_47", vs = "_alignCenter_85404_51", ks = "_alignRight_85404_55", Ns = "_emptyCell_85404_59", W = {
  container: Es,
  table: bs,
  row: fs,
  striped: ys,
  clickable: gs,
  alignLeft: hs,
  alignCenter: vs,
  alignRight: ks,
  emptyCell: Ns
};
function ll({
  columns: t,
  rows: a,
  striped: n = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? W.alignCenter : l === "right" ? W.alignRight : W.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: W.container }, /* @__PURE__ */ e.createElement("table", { className: W.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, a.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: W.emptyCell, colSpan: t.length }, r)) : a.map((l, d) => {
    const c = [
      W.row,
      n && d % 2 === 1 ? W.striped : "",
      o ? W.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: d,
        className: c,
        onClick: o ? () => o(l, d) : void 0
      },
      t.map((i) => /* @__PURE__ */ e.createElement("td", { key: i.key, className: s(i.align) }, l[i.key]))
    );
  }))));
}
const $s = "_grid_plbcd_1", ws = "_cell_plbcd_6", As = "_primaryCell_plbcd_16", xs = "_label_plbcd_21", Xs = "_value_plbcd_26", Cs = "_note_plbcd_32", oe = {
  grid: $s,
  cell: ws,
  primaryCell: As,
  label: xs,
  value: Xs,
  note: Cs
};
function il({
  items: t,
  columns: a = 4,
  primaryFirst: n = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: d,
  primaryLabelColor: c,
  primaryValueColor: i,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: oe.grid,
      style: { gridTemplateColumns: `repeat(${a}, 1fr)` }
    },
    t.map((_, u) => {
      const b = n && u === 0, y = [oe.cell, b ? oe.primaryCell : ""].filter(Boolean).join(" "), E = {};
      o !== void 0 && (E.background = o), r !== void 0 && (E.borderColor = r), b && d !== void 0 && (E.background = d, E.borderColor = "transparent");
      const h = {};
      s !== void 0 && (h.color = s), b && c !== void 0 && (h.color = c);
      const w = {};
      l !== void 0 && (w.color = l), b && i !== void 0 && (w.color = i);
      const X = {};
      return b && m !== void 0 && (X.color = m), /* @__PURE__ */ e.createElement("div", { key: `${_.label}-${u}`, className: y, style: E }, /* @__PURE__ */ e.createElement("span", { className: oe.label, style: h }, _.label), /* @__PURE__ */ e.createElement("span", { className: oe.value, style: w }, _.value), _.note && /* @__PURE__ */ e.createElement("span", { className: oe.note, style: X }, _.note));
    })
  );
}
const Ss = "_button_16ajt_1", Fs = "_disabledSolid_16ajt_19", Bs = "_icon_16ajt_26", js = "_label_16ajt_32", Ls = "_fullWidth_16ajt_37", Is = "_sm_16ajt_41", Ds = "_md_16ajt_47", Ms = "_lg_16ajt_53", Ts = "_primary_16ajt_59", Rs = "_secondary_16ajt_70", Ps = "_outline_16ajt_81", Os = "_ghost_16ajt_93", qs = "_active_16ajt_104", Gs = "_colorOverride_16ajt_116", zs = "_gradient_16ajt_126", Ws = "_dashed_16ajt_135", Ks = "_pill_16ajt_139", I = {
  button: Ss,
  disabledSolid: Fs,
  icon: Bs,
  label: js,
  fullWidth: Ls,
  sm: Is,
  md: Ds,
  lg: Ms,
  primary: Ts,
  secondary: Rs,
  outline: Ps,
  ghost: Os,
  active: qs,
  colorOverride: Gs,
  gradient: zs,
  dashed: Ws,
  pill: Ks
};
function dl({
  variant: t = "primary",
  size: a = "md",
  icon: n,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: d,
  fullWidth: c = !1,
  type: i = "button",
  active: m = !1,
  color: _,
  background: u,
  borderColor: b,
  hoverColor: y,
  hoverBackground: E,
  gradient: h,
  borderStyle: w = "solid",
  shape: X = "rounded"
}) {
  const T = _ !== void 0 || b !== void 0 || y !== void 0 || E !== void 0, O = [
    I.button,
    I[t],
    I[a],
    c ? I.fullWidth : "",
    r && s === "solid" ? I.disabledSolid : "",
    m ? I.active : "",
    T ? I.colorOverride : "",
    h || u ? I.gradient : "",
    w === "dashed" ? I.dashed : "",
    X === "pill" ? I.pill : ""
  ].filter(Boolean).join(" "), q = {
    ..._ !== void 0 ? { "--ax-btn-color": _ } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ...E !== void 0 ? { "--ax-btn-hover-bg": E } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...u !== void 0 ? { background: u } : {}
  }, U = n && /* @__PURE__ */ e.createElement("span", { className: I.icon }, n);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: i,
      className: O,
      style: q,
      disabled: r,
      onClick: l
    },
    o === "leading" && U,
    /* @__PURE__ */ e.createElement("span", { className: I.label }, d),
    o === "trailing" && U
  );
}
const Hs = "_iconButton_1oiog_1", Us = "_sm_1oiog_18", Vs = "_md_1oiog_23", Qs = "_lg_1oiog_28", Js = "_plain_1oiog_33", Ys = "_outline_1oiog_42", Zs = "_circle_1oiog_53", er = "_bordered_1oiog_62", tr = "_tint_1oiog_73", ar = "_active_1oiog_81", nr = "_hoverBgOverride_1oiog_92", or = "_gradient_1oiog_96", J = {
  iconButton: Hs,
  sm: Us,
  md: Vs,
  lg: Qs,
  plain: Js,
  outline: Ys,
  circle: Zs,
  bordered: er,
  tint: tr,
  active: ar,
  hoverBgOverride: nr,
  gradient: or
};
function _l({
  icon: t,
  title: a,
  active: n = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: d = !1,
  color: c,
  hoverColor: i,
  bordered: m = !1,
  borderColor: _ = "#e2e8f0",
  borderHoverColor: u = "#3b82f6",
  tint: b = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: E = "#dbeafe",
  hoverBackground: h,
  gradient: w
}) {
  const X = typeof o == "number", T = [
    J.iconButton,
    X ? "" : J[o],
    J[r],
    n ? J.active : "",
    m ? J.bordered : "",
    b ? J.tint : "",
    h !== void 0 ? J.hoverBgOverride : "",
    w ? J.gradient : ""
  ].filter(Boolean).join(" "), O = {
    ...X ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...i !== void 0 ? { "--ax-icon-hover": i } : {},
    ...m ? { "--ax-icon-border": _, "--ax-icon-border-hover": u } : {},
    ...b ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": E } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...w ? { background: `linear-gradient(135deg, ${w[0]}, ${w[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: T,
      style: O,
      onClick: s,
      onMouseDown: l,
      disabled: d,
      title: a,
      "aria-label": a
    },
    t
  );
}
const sr = "_control_1kv40_1", rr = "_option_1kv40_10", cr = "_active_1kv40_28", lr = "_sm_1kv40_37", ir = "_md_1kv40_43", dr = "_dot_1kv40_49", _r = "_count_1kv40_56", mr = "_outline_1kv40_70", ur = "_outlineOption_1kv40_75", K = {
  control: sr,
  option: rr,
  active: cr,
  sm: lr,
  md: ir,
  dot: dr,
  count: _r,
  outline: mr,
  outlineOption: ur
};
function ml({
  options: t,
  value: a,
  onChange: n,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: d
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[o], r === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((c) => {
      const i = c.value === a, m = i ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...d !== void 0 ? { borderColor: d } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": i,
          className: [K.option, i ? K.active : "", r === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => n(c.value)
        },
        c.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, c.count)
      );
    })
  );
}
const pr = "_chip_8jgxm_1", Er = "_clickable_8jgxm_14", br = "_suggested_8jgxm_23", fr = "_readonly_8jgxm_33", yr = "_plusIcon_8jgxm_39", gr = "_label_8jgxm_45", hr = "_removeButton_8jgxm_50", se = {
  chip: pr,
  clickable: Er,
  default: "_default_8jgxm_18",
  suggested: br,
  readonly: fr,
  plusIcon: yr,
  label: gr,
  removeButton: hr
};
function ul({
  label: t,
  variant: a = "default",
  onRemove: n,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const d = [se.chip, se[a], o ? se.clickable : ""].filter(Boolean).join(" "), i = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = a !== "readonly" && !!n, _ = /* @__PURE__ */ e.createElement(e.Fragment, null, a === "suggested" && /* @__PURE__ */ e.createElement("span", { className: se.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: se.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: se.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (u) => {
        u.stopPropagation(), n == null || n();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: d,
      style: i,
      onClick: o,
      onKeyDown: (u) => {
        (u.key === "Enter" || u.key === " ") && (u.preventDefault(), o());
      }
    },
    _
  ) : /* @__PURE__ */ e.createElement("span", { className: d, style: i }, _);
}
const vr = "_wrapper_15dm4_1", kr = "_disabled_15dm4_8", Nr = "_track_15dm4_13", $r = "_checked_15dm4_30", wr = "_thumb_15dm4_34", Ar = "_label_15dm4_50", re = {
  wrapper: vr,
  disabled: kr,
  track: Nr,
  checked: $r,
  thumb: wr,
  label: Ar
};
function pl({
  checked: t,
  onChange: a,
  labelOn: n,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = t ? n : o;
  return /* @__PURE__ */ e.createElement("label", { className: [re.wrapper, r ? re.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [re.track, t ? re.checked : ""].filter(Boolean).join(" "),
      style: t && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && a(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: re.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: re.label }, l));
}
const xr = "_card_1uh3t_1", Xr = "_active_1uh3t_24", Cr = "_iconChip_1uh3t_29", Sr = "_body_1uh3t_41", Fr = "_label_1uh3t_48", Br = "_description_1uh3t_54", ce = {
  card: xr,
  active: Xr,
  iconChip: Cr,
  body: Sr,
  label: Fr,
  description: Br
};
function El(t) {
  const { icon: a, label: n, description: o, active: r = !1, onClick: s } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${ce.card} ${r ? ce.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: ce.iconChip }, a),
    /* @__PURE__ */ e.createElement("span", { className: ce.body }, /* @__PURE__ */ e.createElement("span", { className: ce.label }, n), o && /* @__PURE__ */ e.createElement("span", { className: ce.description }, o))
  );
}
const jr = "_breadcrumb_zkol9_1", Lr = "_list_zkol9_6", Ir = "_item_zkol9_16", Dr = "_link_zkol9_22", Mr = "_plain_zkol9_43", Tr = "_current_zkol9_48", Rr = "_separator_zkol9_54", ae = {
  breadcrumb: jr,
  list: Lr,
  item: Ir,
  link: Dr,
  plain: Mr,
  current: Tr,
  separator: Rr
};
function bl(t) {
  const { items: a, separator: n = "/", textColor: o, hoverColor: r, currentColor: s } = t, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: ae.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: ae.list }, a.map((d, c) => {
    const i = c === a.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: c, className: ae.item }, i ? /* @__PURE__ */ e.createElement("span", { className: ae.current, "aria-current": "page" }, d.label) : d.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ae.link,
        onClick: d.onClick
      },
      d.label
    ) : /* @__PURE__ */ e.createElement("span", { className: ae.plain }, d.label), !i && /* @__PURE__ */ e.createElement("span", { className: ae.separator, "aria-hidden": "true" }, n));
  })));
}
const Pr = "_treeItem_1ouqz_1", Or = "_active_1ouqz_18", qr = "_chevron_1ouqz_28", Gr = "_chevronExpanded_1ouqz_48", zr = "_chevronSpacer_1ouqz_52", Wr = "_icon_1ouqz_57", Kr = "_label_1ouqz_69", Hr = "_count_1ouqz_76", Ur = "_dark_1ouqz_86", H = {
  treeItem: Pr,
  active: Or,
  chevron: qr,
  chevronExpanded: Gr,
  chevronSpacer: zr,
  icon: Wr,
  label: Kr,
  count: Hr,
  dark: Ur
};
function fl(t) {
  const {
    icon: a,
    label: n,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: d = !1,
    theme: c = "light",
    onToggleExpand: i,
    onClick: m
  } = t, _ = (b) => {
    b.stopPropagation(), i == null || i();
  }, u = c === "dark" ? H.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${H.treeItem} ${u} ${s ? H.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? d : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${H.chevron} ${d ? H.chevronExpanded : ""}`,
        onClick: _,
        "aria-label": d ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: H.chevronSpacer }),
    a && /* @__PURE__ */ e.createElement("span", { className: H.icon }, a),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, n),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: H.count }, o)
  );
}
const Vr = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Ge(t) {
  return Array.from(t.querySelectorAll(Vr)).filter((a) => a.getClientRects().length > 0 && getComputedStyle(a).visibility !== "hidden");
}
let ze = 0, We = "";
function tt(t) {
  const a = Y(null), n = Y(t);
  n.current = t;
  const o = Y(void 0);
  return o.current === void 0 && (o.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var d;
    const s = a.current, l = (d = o.current) != null ? d : null;
    return s && !s.contains(document.activeElement) && (Ge(s)[0] || s).focus(), ze++ === 0 && (We = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --ze === 0 && (document.body.style.overflow = We), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: a, onKeyDown: (s) => {
    const l = a.current;
    if (!l) return;
    if (s.key === "Escape") {
      s.stopPropagation(), n.current();
      return;
    }
    if (s.key !== "Tab" || !l.contains(s.target)) return;
    const d = Ge(l);
    if (d.length === 0) {
      s.preventDefault(), l.focus();
      return;
    }
    const c = d[0], i = d[d.length - 1], m = document.activeElement;
    s.shiftKey && (m === c || m === l) ? (s.preventDefault(), i.focus()) : !s.shiftKey && m === i && (s.preventDefault(), c.focus());
  } };
}
const Qr = "_backdrop_gstyy_1", Jr = "_panel_gstyy_9", Yr = "_right_gstyy_21", Zr = "_left_gstyy_27", ec = "_header_gstyy_51", tc = "_icon_gstyy_59", ac = "_titleGroup_gstyy_66", nc = "_kicker_gstyy_71", oc = "_title_gstyy_66", sc = "_subtitle_gstyy_87", rc = "_closeButton_gstyy_93", cc = "_body_gstyy_115", lc = "_footer_gstyy_123", j = {
  backdrop: Qr,
  panel: Jr,
  right: Yr,
  left: Zr,
  header: ec,
  icon: tc,
  titleGroup: ac,
  kicker: nc,
  title: oc,
  subtitle: sc,
  closeButton: rc,
  body: cc,
  footer: lc
};
function yl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(ic, { ...t }) : null;
}
function ic({
  onClose: t,
  icon: a,
  kicker: n,
  title: o,
  titleSize: r,
  titleWeight: s,
  subtitle: l,
  footer: d,
  children: c,
  side: i = "right",
  headerBackground: m,
  topOffset: _
}) {
  const { dialogRef: u, onKeyDown: b } = tt(t), y = Ke("ax-drawer-t"), E = [j.panel, i === "left" ? j.left : j.right].filter(Boolean).join(" "), h = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, w = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: j.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: u,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: E,
      style: w,
      onClick: (X) => X.stopPropagation(),
      onKeyDown: b
    },
    /* @__PURE__ */ e.createElement("div", { className: j.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: j.icon }, a), /* @__PURE__ */ e.createElement("div", { className: j.titleGroup }, n && /* @__PURE__ */ e.createElement("p", { className: j.kicker }, n), /* @__PURE__ */ e.createElement("h2", { className: j.title, id: y, style: h }, o), l && /* @__PURE__ */ e.createElement("p", { className: j.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: j.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: j.body }, c),
    d && /* @__PURE__ */ e.createElement("div", { className: j.footer }, d)
  ));
}
const dc = "_backdrop_6kso7_1", _c = "_menu_6kso7_8", mc = "_alignRight_6kso7_24", uc = "_alignLeft_6kso7_28", pc = "_item_6kso7_32", Ec = "_itemIcon_6kso7_50", bc = "_itemText_6kso7_59", fc = "_itemLabel_6kso7_66", yc = "_itemDescription_6kso7_72", gc = "_danger_6kso7_77", R = {
  backdrop: dc,
  menu: _c,
  alignRight: mc,
  alignLeft: uc,
  item: pc,
  itemIcon: Ec,
  itemText: bc,
  itemLabel: fc,
  itemDescription: yc,
  danger: gc
};
function gl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(hc, { ...t }) : null;
}
function hc({
  onClose: t,
  items: a,
  anchor: n = "right"
}) {
  const o = Y(null), r = Y(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var i, m, _;
    const c = (i = r.current) != null ? i : null;
    return (_ = (m = o.current) == null ? void 0 : m.querySelector("button")) == null || _.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const s = [R.menu, n === "left" ? R.alignLeft : R.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), t();
  }, d = (c) => {
    var u, b;
    const i = Array.from((b = (u = o.current) == null ? void 0 : u.querySelectorAll("button")) != null ? b : []), m = i.indexOf(document.activeElement), _ = (y) => {
      var E;
      c.preventDefault(), (E = i[(y + i.length) % i.length]) == null || E.focus();
    };
    c.key === "ArrowDown" ? _(m + 1) : c.key === "ArrowUp" ? _(m <= 0 ? i.length - 1 : m - 1) : c.key === "Home" ? _(0) : c.key === "End" ? _(i.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), t());
  };
  return /* @__PURE__ */ e.createElement(at, null, /* @__PURE__ */ e.createElement("div", { className: R.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { ref: o, role: "menu", className: s, onClick: (c) => c.stopPropagation(), onKeyDown: d }, a.map((c, i) => {
    const m = [R.item, c.danger ? R.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: i,
        type: "button",
        role: "menuitem",
        className: m,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ e.createElement("span", { className: R.itemIcon }, c.icon),
      /* @__PURE__ */ e.createElement("span", { className: R.itemText }, /* @__PURE__ */ e.createElement("span", { className: R.itemLabel }, c.label), c.description && /* @__PURE__ */ e.createElement("span", { className: R.itemDescription }, c.description))
    );
  })));
}
const vc = "_backdrop_3pc9i_1", kc = "_card_3pc9i_12", Nc = "_header_3pc9i_23", $c = "_icon_3pc9i_31", wc = "_titleGroup_3pc9i_38", Ac = "_title_3pc9i_38", xc = "_subtitle_3pc9i_50", Xc = "_closeButton_3pc9i_56", Cc = "_body_3pc9i_78", Sc = "_footer_3pc9i_85", P = {
  backdrop: vc,
  card: kc,
  header: Nc,
  icon: $c,
  titleGroup: wc,
  title: Ac,
  subtitle: xc,
  closeButton: Xc,
  body: Cc,
  footer: Sc
};
function hl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Fc, { ...t }) : null;
}
function Fc({
  onClose: t,
  icon: a,
  title: n,
  subtitle: o,
  footer: r,
  width: s = 480,
  children: l
}) {
  const { dialogRef: d, onKeyDown: c } = tt(t), i = Ke("ax-modal-t"), m = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ e.createElement("div", { className: P.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: d,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": i,
      className: P.card,
      style: { width: m },
      onClick: (_) => _.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ e.createElement("div", { className: P.header }, a && /* @__PURE__ */ e.createElement("span", { className: P.icon }, a), /* @__PURE__ */ e.createElement("div", { className: P.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: P.title, id: i }, n), o && /* @__PURE__ */ e.createElement("p", { className: P.subtitle }, o)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: P.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: P.body }, l),
    r && /* @__PURE__ */ e.createElement("div", { className: P.footer }, r)
  ));
}
export {
  Ce as ACTIVE_AFFILIATION_KEY_PREFIX,
  pt as ACTIVE_COM_HEADER,
  Et as ACTIVE_DEPT_HEADER,
  El as AXActionCard,
  Kc as AXAiIconBadge,
  al as AXAiSuggestionBanner,
  et as AXAvatar,
  Hc as AXAvatarStack,
  Uc as AXBadge,
  bl as AXBreadcrumb,
  dl as AXButton,
  Gc as AXCardPanel,
  Vc as AXCommentRow,
  Oc as AXCommentThread,
  ll as AXDataTable,
  zc as AXDivider,
  yl as AXDrawer,
  gl as AXDropdownMenu,
  nl as AXEmptyState,
  Ll as AXErpAccordion,
  Il as AXErpActionMenu,
  Dl as AXErpAiAnswerPanel,
  Ml as AXErpBanner,
  Tl as AXErpBarChart,
  Rl as AXErpButton,
  Pl as AXErpCalculatorModal,
  Ol as AXErpCalculatorProvider,
  ql as AXErpCalendar,
  Gl as AXErpCard,
  zl as AXErpCheckGroup,
  Wl as AXErpCheckList,
  Kl as AXErpCheckbox,
  Hl as AXErpCodeBadge,
  Ul as AXErpCodePicker,
  Vl as AXErpContextHelp,
  Ql as AXErpContextMenu,
  Jl as AXErpCriticalAlert,
  Yl as AXErpCsvButton,
  Zl as AXErpCsvPick,
  ei as AXErpDataTable,
  ti as AXErpDatePicker,
  ai as AXErpDateRange,
  ni as AXErpDonutChart,
  oi as AXErpDropArea,
  si as AXErpError,
  ri as AXErpField,
  ci as AXErpFileButton,
  li as AXErpFileDrop,
  ii as AXErpFilterBand,
  di as AXErpFormModal,
  _i as AXErpFormRow,
  mi as AXErpFormSection,
  ui as AXErpGantt,
  pi as AXErpGisuField,
  Ei as AXErpGlyph,
  bi as AXErpGrid,
  fi as AXErpGridStatus,
  yi as AXErpHint,
  gi as AXErpIcon,
  hi as AXErpIconButton,
  vi as AXErpImageThumbs,
  ki as AXErpKanban,
  Ni as AXErpKpiTile,
  $i as AXErpKpiTileGroup,
  wi as AXErpLinkButton,
  Ai as AXErpLoadMore,
  xi as AXErpMainScreen,
  Xi as AXErpMenuAreaHead,
  Ci as AXErpMenuGroup,
  Si as AXErpMiniCalendar,
  Fi as AXErpModal,
  Bi as AXErpMoneyInput,
  ji as AXErpMsg,
  Li as AXErpMultiSelect,
  Ii as AXErpNote,
  Di as AXErpOverviewGrid,
  Mi as AXErpPage,
  Ti as AXErpPageBody,
  Ri as AXErpPageFrame,
  Pi as AXErpPagination,
  Oi as AXErpPill,
  qi as AXErpPopover,
  Gi as AXErpProgressBar,
  zi as AXErpProposalBanner,
  Wi as AXErpProposalCards,
  Ki as AXErpProposalList,
  Hi as AXErpProposalModal,
  Ui as AXErpQtyInput,
  Vi as AXErpQuickMenu,
  Qi as AXErpRadioGroup,
  Ji as AXErpReadonly,
  Yi as AXErpReadout,
  Zi as AXErpSaveBar,
  ed as AXErpSearchBar,
  td as AXErpSelect,
  ad as AXErpShortcutHelp,
  nd as AXErpSideBar,
  od as AXErpSidePanel,
  sd as AXErpSidePanelGroup,
  rd as AXErpSkipLink,
  cd as AXErpSortAnnounce,
  ld as AXErpSortTh,
  id as AXErpSpinner,
  dd as AXErpStartGuide,
  _d as AXErpStatCard,
  md as AXErpStateBadge,
  ud as AXErpStepIndicator,
  pd as AXErpSummaryCard,
  Ed as AXErpSummaryList,
  bd as AXErpSwitch,
  fd as AXErpTabs,
  yd as AXErpTag,
  gd as AXErpTagList,
  hd as AXErpTextInput,
  vd as AXErpTitleBar,
  kd as AXErpToastProvider,
  Nd as AXErpToggle,
  $d as AXErpTooltip,
  wd as AXErpTreeCell,
  Ad as AXErpVerify,
  xd as AXErpVirtualBody,
  Xd as AXErpVisuallyHidden,
  Cd as AXErpWeekStepper,
  Sd as AXErpWeekStrip,
  ol as AXExpandableSummary,
  Qc as AXFileChip,
  dn as AXFileTypeIcon,
  _l as AXIconButton,
  il as AXKeyValueGrid,
  Jc as AXKeyValueRow,
  Yc as AXListRow,
  hl as AXModal,
  Wc as AXPanelHeader,
  Zc as AXPersonRow,
  sl as AXProgressBar,
  el as AXRankingRow,
  Fd as AXSearchInput,
  ml as AXSegmentedControl,
  tl as AXStatusBadge,
  rl as AXStepProgress,
  ul as AXTagChip,
  pl as AXToggleSwitch,
  fl as AXTreeItem,
  cl as AXTypingDots,
  Bd as AX_ERP_CALENDAR_KO,
  jd as AX_ERP_DIRTY_MESSAGE,
  Ld as AX_ERP_SHORTCUTS,
  Rc as CurrencyUnit,
  je as GW_ORIGIN,
  Id as JAPANESE_ERAS,
  Dd as OBTPortal,
  Md as OBTResizeContainer,
  Td as OBTResizeSensor,
  ge as REFRESH_KEY,
  Xe as SESSION_EXPIRED_EVENT,
  Be as TOKEN_KEY,
  bt as activeAffiliationHeaders,
  Nl as amDigits,
  $l as amNumber,
  le as authorizedFetch,
  Rd as axErpAddDays,
  Pd as axErpAriaSort,
  Od as axErpAutoLineAm,
  qd as axErpCalendarLocale,
  Gd as axErpChangedKeys,
  zd as axErpCodeDisplay,
  Wd as axErpCodeLabel,
  Kd as axErpCodeNameOf,
  Hd as axErpCompareSortValue,
  Ud as axErpDownload,
  Vd as axErpFileName,
  Qd as axErpGisuLabel,
  Jd as axErpHttpMessage,
  Yd as axErpIsHelpKey,
  Zd as axErpKeepInPlace,
  e_ as axErpKpiColumns,
  t_ as axErpMenuItem,
  a_ as axErpMenuSection,
  n_ as axErpMergeBase,
  o_ as axErpNextSort,
  s_ as axErpPageCount,
  r_ as axErpPageItems,
  c_ as axErpParsePage,
  l_ as axErpQtyDecimals,
  i_ as axErpQtyFormat,
  d_ as axErpQtyOutOfRange,
  __ as axErpQtyParse,
  m_ as axErpQtyRound,
  u_ as axErpQtyStep,
  p_ as axErpQtyTimesUnit,
  E_ as axErpRangeValid,
  b_ as axErpRovingMove,
  f_ as axErpRowActivate,
  y_ as axErpSameValues,
  g_ as axErpSaveBlob,
  h_ as axErpSaveCsv,
  v_ as axErpSortForest,
  k_ as axErpSortMessage,
  N_ as axErpSortValue,
  $_ as axErpSubmitShortcutLabel,
  w_ as axErpTableToCsv,
  A_ as axErpTotalLabel,
  x_ as axErpWeekOf,
  lt as clearTokens,
  Ic as colors,
  Dc as configureAuth,
  Pc as configureComments,
  X_ as csvFormulaGuard,
  C_ as csvNumber,
  st as currencyDigits,
  Ye as currentUsername,
  we as decodeClaims,
  S_ as eraOf,
  F_ as eraShortDate,
  B_ as eraYearLabel,
  wl as fmtAm,
  j_ as fmtDt,
  Al as fmtDtMin,
  ot as fmtMoney,
  xl as fmtMoneyText,
  Xl as fmtNum,
  Cl as fmtNumBlank,
  Sl as fmtNumDash,
  Fl as fmtYen,
  Ze as getActiveAffiliation,
  ut as getFreshToken,
  Ve as getStoredToken,
  rt as isExpired,
  Ue as isRefreshExpired,
  kt as isReply,
  L_ as measureMoneyMetrics,
  I_ as moneyColWidth,
  D_ as moneyColWidthForDigits,
  nt as moneyUnit,
  fe as notifySessionExpired,
  Mc as onSessionExpired,
  gt as pickCurrencyCode,
  Je as refreshTokens,
  ct as saveTokens,
  Tc as setActiveAffiliation,
  dt as startRefreshExpiryWatch,
  Qe as stopRefreshExpiryWatch,
  M_ as textColWidth,
  T_ as textWidth,
  ht as toCurrency,
  Bl as toHalfWidth,
  R_ as todayLocal,
  P_ as useAXErpBusy,
  O_ as useAXErpCalculator,
  q_ as useAXErpConfirm,
  G_ as useAXErpDirtyGuard,
  z_ as useAXErpEditor,
  W_ as useAXErpFilePicker,
  K_ as useAXErpNotice,
  H_ as useAXErpPaged,
  U_ as useAXErpQuery,
  V_ as useAXErpQuickMenu,
  Q_ as useAXErpRovingGrid,
  J_ as useAXErpRunLock,
  Y_ as useAXErpShortcutHelp,
  Z_ as useAXErpSubmitShortcut,
  em as useAXErpToast,
  tm as useAXErpTree,
  Ke as useAXErpUid,
  qc as useCommentCounts,
  Xt as useComments,
  vt as useCurrency
};
